import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportSubmissionGroup'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { ReportSubmissions } from '@/components/reporting/submissions/reportSubmissions'

@localized()
class ReportSubmissionsPage extends React.Component {
  componentDidMount () {
    this.reload()
  }
  componentDidUpdate (prevProps, prevState) {
    if (this.props.match.params.parentId !== prevProps.match.params.parentId ||
      this.props.reportSubmissionGroup.pageKey !== prevProps.reportSubmissionGroup.pageKey) {
      this.reload()
    }
  }
  reload () {
    this.props.get(this.props.match.params.parentId)
  }
  render () {
    const { addAttachments, reportSubmissionGroup, previousSubmissionGroupState } = this.props

    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl='/report-submission-groups'>
            <Resx name='Reporting.ReportGroupSubmissionDetailTitle' />
          </MainTopTitle>
        </MainTop>
        <MainBody transparent>
          <ReportSubmissions
            parentId={this.props.match.params.parentId}
            forecasting={false}
            detailUrlFormat='/report-submission-groups/{0}/report-submissions/{1}'
            addAttachments={addAttachments}
            reportSubmissionGroup={reportSubmissionGroup}
            showInstitution
            showRelatedLinks
            previousSubmissionGroupState={previousSubmissionGroupState}
          />
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportSubmissionGroup: state.reportSubmissionGroup,
    previousSubmissionGroupState: state.reportSubmissionGroup.previousSubmissionGroupState,
    ...ownProps
  }
}

const mapDispatchToProps = {
  get: actionCreators.get
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportSubmissionsPage)



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportSubmissionGroups/submissions/reportSubmissions.js